import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { brandsThunk } from "../../../store/thunks/brandThunk";

export const BrandDropdown = ({
  onChange,
  value,
  isMulti,
  required,
  error,
  onInputChange,
  isDisabled,
}) => {
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state?.brandsList || {});

  useEffect(() => {
    dispatch(brandsThunk());
  }, [dispatch]);

  return (
    <>
      <label className="font-weight-bolder font-size-sm">
        Brand Name {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <Select
        className={`w-100 max-w-500px ${error ? "invalid" : ""}`}
        isClearable
        placeholder="Select Brand Name"
        isMulti={isMulti}
        isDisabled={isDisabled}
        onInputChange={onInputChange}
        value={
          Array.isArray(value)
            ? data?.length > 0
              ? data
                  .filter((obj) => value.includes(obj.id))
                  .map(({ id, name }) => ({
                    label: name?.en?.toUpperCase(),
                    value: id,
                  }))
              : []
            : data?.length > 0
            ? data
                .filter((obj) => obj.id === value)
                .map(({ id, name }) => ({
                  label: name?.en?.toUpperCase(),
                  value: id,
                }))
            : []
        }
        options={
          data?.length > 0
            ? data.map((dataList, index) => {
                const id = dataList.id;
                const { en } = dataList.name;
                return { label: en?.toUpperCase(), value: id };
              })
            : []
        }
        onChange={onChange}
      ></Select>
      <small className="text-danger">{error}</small>
    </>
  );
};
